var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.24747,
    transform: "matrix(-1 0 0 1 12.3404 3.24747)",
    fill: "#E2E2E2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3.24747,
    transform: "matrix(-1 0 0 1 12.3404 12.3407)",
    fill: "#E2E2E2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 3.24747,
    transform: "matrix(-1 0 0 1 12.3404 21.4335)",
    fill: "#E2E2E2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 3.24747,
    transform: "matrix(-1 0 0 1 3.24764 3.24747)",
    fill: "#E2E2E2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 3.24747,
    transform: "matrix(-1 0 0 1 3.24764 12.3407)",
    fill: "#E2E2E2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 3.24747,
    transform: "matrix(-1 0 0 1 3.24764 21.4335)",
    fill: "#E2E2E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/drag_drop.acd75afba02ab96fedddefaec23201d4.svg";
export { ForwardRef as ReactComponent };